import { ThemeEnum } from "@components/ThemeProvider/ThemeProvider";
import clsx from "clsx";

import Link from "../Link";

type CategoryTagProps = {
  name?: string;
  href?: string;
  theme?: ThemeEnum;
  className?: string;
};

export default function CategoryTag({
  name = "",
  href,
  theme = ThemeEnum.light,
  className,
  ...props
}: CategoryTagProps & React.HTMLAttributes<HTMLAnchorElement>) {
  const isVideo = theme === ThemeEnum.dark;

  return (
    <Link
      to={href || ""}
      className={clsx(
        "relative z-10 inline-flex w-fit shrink-0 items-center rounded-full px-2 py-1",
        isVideo ? "bg-button-primary" : "bg-background-quarternary",
        className,
      )}
      {...props}
    >
      <p
        className={clsx(
          "text-label-2 shrink-0 font-bold",
          isVideo ? "text-white" : "text-brand-primary",
        )}
      >
        {name}
      </p>
    </Link>
  );
}
